import React, { useEffect, useState, useRef } from 'react';
import { ContentLayout } from 'components/Layout';
import { useMostRecents } from '../api/getMostRecents';
import { Box, Stack, Typography, Link } from '@mui/material';
import { BreadCrumbs } from 'components/Breadcrumbs';
import { paths } from 'routes';
import { useAuth } from 'lib/auth';
import { PremiumBanner } from 'features/subscriptions/components/PremiumBanner';
import { Loader } from 'components/Loader';
import { NotFound } from 'components/NotFound/NotFound';
import { HomeListItem } from '../components/HomeListItem';
import { ListCard, PaperCard } from 'components/Card';
import { useGetAll } from 'features/blog/api/getAll';
import { BlogListItem } from '../components/BlogListIem';
import { Link as RouterLink } from 'react-router-dom';

export const Homepage = () => {
  const { account, user } = useAuth();
  const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [filters, setFilters] = useState({
      includeInactive: false,
      includeExpired: true,
      sortBy: 'dateCreated',
    });
    const [loading, setLoading] = useState(false);
    const [timer, setTimer] = useState(null);

  const {
    data: { results, total },
    refetch: refetchHome,
    isFetching: isFetching1,
  } = useMostRecents({
    search,
    ...filters,
    page: page - 1,
    queryOptions: {
      onSettled: () => {
        clearTimeout(timer);
        setTimeout(() => setLoading(false), 1000);
      }
    },
  });

  const {
    data: {blogs, total: totalBlogs},
    refetch: refetchBlog,
    isFetching: isFetching2,
  } = useGetAll({
    page: page - 1,
    limit: 2,
    queryOptions: {
      onSettled: () => {
        clearTimeout(timer);
        setTimeout(() => setLoading(false), 1000);
      }
    },
  })

  const refElementToMatch = useRef(null);
  const [targetHeight, setTargetHeight] = useState(null);

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      if (entries && entries[0]) {
        setTargetHeight(entries[0].contentRect.height);
      }
    });

    if (refElementToMatch.current) {
      observer.observe(refElementToMatch.current);
    }

    return () => {
      if (refElementToMatch.current) {
        observer.unobserve(refElementToMatch.current);
      }
    };
  }, []);

  useHomeRefetch();

  const isFetching = isFetching1 || isFetching2;

  return (
    <ContentLayout>
      <Stack height={1} width={1}>
        <Stack>
          <BreadCrumbs
            items={[
              { name: '', to: paths.homepage },
              { name: `Home` },
              // { name: `Home${total > 0 ? ` (${total})` : ''}` },
            ]}
          />
        </Stack>
        {!account.super_admin && user.Company.subscription_level !== "gold" && (
          <Box>
            <PremiumBanner sx={{my: 0}} message={`Read more about our Premium offerings here`} currentLevel={user.Company.subscription_level} />
          </Box>
        )}
        <Stack
          px={4}
          py={2}
          bgcolor="background.paper"
          height="100%"
          width={1}
          boxSizing={"border-box"}
          flexDirection={"row"}
          gap={4}
        >
          <Stack ref={refElementToMatch} direction="row" gap={2} alignSelf="center" flex={2}>
          {isFetching && !loading ? 
          (
            <></>
          ) :
          (!isFetching || (isFetching && loading)) ?
          (
            <>
            {loading ? (
              <Loader />
            ):
            (
            <>
              {!results && (
                <Stack
                  height="100%"
                  sx={{
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography variant="h5">Nothing found</Typography>
                </Stack>
              )}
              {results && (
                <>
                  <Stack
                    flex={1}
                    bgcolor="background.paper"
                    gap={2}
                    height={1}
                  >
                    {results.length === 0 && (
                      <NotFound
                        wrapperSx={{ mt: "25%" }}
                        title="Nothing found"
                      />
                    )}
                    {results.length !== 0 &&
                      results.map((item) => (
                        <HomeListItem key={item.type + item.id} {...item} />
                      ))}
                  </Stack>
                </>
              )}
            </>
            )}
            </>
          ) :
          (
            <></>
          )}
          </Stack>
          <Stack flex={1} height={1} sx={{justifyContent: "space-between"}} gap={1}>
            {(!blogs || blogs.length === 0) && (
              <ListCard sx={{width: 1, height: targetHeight ? targetHeight : 1, boxSizing: 'border-box', justifyContent: "center"}}  flexDirection={"column"}><></></ListCard>
            )}
            {blogs && blogs.length !== 0 &&
              blogs.map((item) => (
              <BlogListItem key={item.blog_id} length={blogs.length} {...item} />
            ))}
            {/* {totalBlogs > 2 && ( */}
              <PaperCard
                sx={{
                  boxShadow: 0,
                  borderRadius: 1,
                  p: 0.5,
                  height: "20px",
                }}
              >
                <Link
                  component={RouterLink}
                  to={`${paths.blog}`}
                  color="inherit"
                  underline='none'
                  sx={{height:1}}
                >
                  <Typography variant="body2" justifySelf={"center"} fontWeight={500}>
                    Click here to see more
                  </Typography>
                </Link>
              </PaperCard>
            {/* )} */}
          </Stack>
        </Stack>
      </Stack>
    </ContentLayout>
  );

  function useHomeRefetch() {
      useEffect(() => {
        refetchHome();
      }, [
        page,
        filters,
        search,
      ]);
    }
};
